export const ENABLE_TEXT = 'Are you sure you want to activate the middleware?';
export const DISABLE_TEXT = 'Are you sure you want to deactivate the middleware?';
export const DELETE_TEXT = 'Are you sure you want to delete the middleware?';

export const DELETE_DISABLED_TOOLTIP = 'This Middleware can only be deleted after unlinking it from existing Network Elements';

export const ENABLE_PM_FILES_STORING = 'Are you sure you want to enable PM files storing?';
export const DISABLE_PM_FILES_STORING = 'Are you sure you want to disable PM files storing?';

export const MIDDLEWARE_TABS_NAMES = {
	middlewares: 'Middlewares',
	connectionLogs: 'Connection Status Logs',
};

export const CONNECTION_LOGS_FIELD_NAMES = {
	connectionStatus: 'connectionStatus',
	eventType: 'eventType',
	source: 'source',
	userId: 'userId',
	middlewareId: 'middlewareId',
	systemId: 'systemId',
	userName: 'userName',
	createdAtText: 'createdAtText',
} as const;

export const CONNECTION_LOGS_LABELS = {
	connectionStatus: 'Connection Status',
	eventType: 'Event Type',
	source: 'Source',
	user: 'User',
	middleware: 'Middleware',
	dateTime: 'Date & Time',
	id: 'ID',
} as const;

export const CONNECTION_LOGS_PLACEHOLDERS = {
	middleware: 'ID',
	eventType: 'Event Type',
	connectionStatus: 'Connection Status',
	source: 'Source',
	user: 'User',
} as const;
